import { useLocalStorage } from "usehooks-ts";
import { DiscoveryPreOrderMonthsResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";

export const useDiscoveryPreOrdersMonths = <
  TData = DiscoveryPreOrderMonthsResponseType,
>(
  options?: ApiV2QueryOptions<TData>,
) => {
  const [unAuthorisedUserPostcode] = useLocalStorage(
    "unauthorisedUserPostcode",
    "",
  );
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      "pre-orders-months",
      user?.uid,
      business?.id,
      unAuthorisedUserPostcode,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `pre-orders-months`,
        params: { unAuthorisedUserPostcode },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
